"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationService = void 0;
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const axios_1 = __importDefault(require("axios"));
class NotificationService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key, token = '') {
        this.RESOURCE = 'notifications';
        /**
         * Mark as Read
         * @param userId **type** number
         * @returns <object> = {message:'success'}
         */
        /* //Este esta repetido, converse com movil y se queda el PUT es el que se usa en POINT WEB y MOVIL
         async markAsRead (userId: number): Promise<{message:string}>{
             const URL =`${API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${userId}`;
             const response = await axios.get(URL, {headers:{'x-api-key':  this.key}});
             return  (response.status===200)? Promise.resolve(response.data): Promise.reject(response.statusText);
         } */
        this.markAsRead = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.put(URL, {}, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getNotifications = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getAllList = async (page, viewAll) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}?page=${page}&viewall=${viewAll ? 1 : 0}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.search = async (page, searchText, viewAll) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}?page=${page}&search=${searchText}&viewall=${viewAll ? 1 : 0}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.get = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/entry/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.update = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/entry/${id}`;
            const response = await axios_1.default.put(URL, JSON.stringify(body), { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.Delete = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/entry/${id}`;
            const response = await axios_1.default.delete(URL, { headers: { 'x-api-key': this.key } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.key = key;
        this.token = token;
    }
    /**
     * Retriveas all **Notificationes**
     * @param userId
     * @returns
     */
    async getAllByUserId(userId) {
        const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${userId}`;
        const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.key } });
        return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
    }
}
exports.NotificationService = NotificationService;
